import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class LecturerToggles extends Module {

    ready(app) {

        const LECTURER_TOGGLES = document.querySelectorAll('.mtt-course-lecturers');

        if (LECTURER_TOGGLES.length > 0) {
            for (let i = 0; i < LECTURER_TOGGLES.length; i++) {
                const LECTURER_TOGGLE = LECTURER_TOGGLES[i];
                const lecturerToggle = new LecturerToggle(LECTURER_TOGGLE);
                lecturerToggle.init();
            }
        }
    }
}


class LecturerToggle {
    constructor(WRAPPER){
        this.WRAPPER = WRAPPER;
        this.IMAGES = this.WRAPPER.querySelectorAll('[data-image]');
        this.LECTURERS = this.WRAPPER.querySelectorAll('[data-lecturer]');
        
    }

    init(){
        if (this.IMAGES.length > 0) {
            for (let i = 0; i < this.IMAGES.length; i++) {

                const IMAGE = this.IMAGES[i];
                let ACTIVELECTURER = null;

                IMAGE.addEventListener('click', () => {

                    let image_id = IMAGE.getAttribute('data-image');

                    // Add image class
                    for (let i = 0; i < this.IMAGES.length; i++) {
                        removeClass(this.IMAGES[i], 'active');
                    }
                    addClass(IMAGE, 'active');

                    if (this.LECTURERS.length > 0) {
                        for (let i = 0; i < this.LECTURERS.length; i++) {

                            const LECTURER = this.LECTURERS[i];
                            let lecturer_id = LECTURER.getAttribute('data-lecturer');

                            if (lecturer_id === image_id) {
                                addClass(LECTURER, 'active');
                                ACTIVELECTURER = LECTURER;
                            } else {
                                removeClass(LECTURER, 'active');
                            }

                        }
                    }

                    $('html, body').animate({ 
                        scrollTop: $(ACTIVELECTURER).offset().top - 130
                    }, 800);
                });
            }
        }
    }
}